import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Marquee from "../components/Marquee";
import FeaturedEpisode from "../components/FeaturedEpisode";
import Categories from "../components/Categories";
import FeaturedPicks from "../components/FeaturedPicks";
import MostLoved from "../components/MostLoved";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import SEO from "../components/SEO";

const Home = () => {
  const location = useLocation();

  useEffect(() => {
    const target = location.state && location.state.scrollTo;
    if (target) {
      // wait for sections to mount
      setTimeout(() => {
        const el = document.getElementById(target);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 200);
    }
  }, [location.state]);

  return (
    <div className="bg-[#eceae5]">
      <SEO type="website" />
      <Navbar />
      <Hero />
      <Marquee />
      <FeaturedEpisode />
      <MostLoved />
      <FeaturedPicks />
      <Categories />
      <Contact />
      <Footer />
    </div>
  );
};

export default Home;
